





















import Vue from 'vue';
import BravadoTheme from '@/components/common/BravadoTheme/BravadoTheme.vue';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import LinkedinIcon from '~/assets/svg/linkedin.vue.svg';

export default Vue.extend({
  name: 'SignUpSocialButtons',
  components: {
    LinkedinIcon,
    BravadoButtonV3,
    BravadoTheme,
    GoogleIcon: () => import('@/components/Icon/GoogleIcon.vue'),
  },
});
